<h1 mat-dialog-title class="d-flex align-items-center justify-content-between">
  <span class="dialog-header">Upload Documents</span>
  <i mat-dialog-close class="fa fa-times model_close cursor-pointer"></i>
</h1>
<div mat-dialog-content class="template-upload-content custom_Scrollbar">
  <div class="template-upload-modal">
    <div class="dropzone text-center" fileDragDrop (click)="file.click()" (dragover)="onDragOver($event)"
      (dragleave)="onDragLeave($event)" (drop)="onDrop($event)" style="margin-bottom:6px; border: 2px dashed #1849D6;">

      <i class="msicon">
        <span class="material-symbols-rounded" style="font-size: 36px;">
          backup
        </span>
      </i>
      <p class="drag-drop h5" style="color: #212121; margin-top:12px;font-size: 0.79rem;">
        Drag your file(s) or
        <a class="text-decoration-underline" style="color: #1849D6; font-weight: 600;">browse</a>
      </p>
      <p class="drag-drop h6" style="color: #4C4C4C; margin-top: 8px;font-size: 0.79rem;">Maximum file size up to 20MB.</p>
      <input #file type="file" class="form-control d-none" name="file" id="file" accept=".doc, .pdf, .docx"
        (change)="onFileChange($event.target.files)" multiple>
    </div>
    <!-- Error message section -->
    <p class="text-danger mt-2" *ngIf="fileSizeError">{{ fileSizeError }}</p>
    <div class="file-list docs" style="width: 100%;">
      <ul class="list-group list-group-flush">
        <li class="list-group-item file-row" *ngFor="let file of selectedFiles; let i = index">
          <div class="d-flex align-items-center justify-content-between temp"
            style="background-color: #EBEBEB;width : 100%; padding-bottom: 4px;">
            <!-- File name and size on the left -->
            <div class="d-flex align-items-center">
              <div class="avatar"><span class="material-symbols-outlined fs-18 add-circle"> description
                </span>
              </div>
              <div>
                <div class="h3 file-name-custom" style="margin-bottom: 6px;"
                  [ngClass]="data && data.categoryTypes ? 'file-name-overflow' : 'file-name'" [title]="file.name">
                  {{ truncateFileName(file.name) }}
                </div>
                <p class="size-text h6 mb-0" style="margin: 1px;"><small style="font-weight: 500; color: #3A3A3C;">{{ file.size | sizeConverson }}</small></p>
                <p class="size-text h6 text-danger mb-0" style="margin-bottom: 2px;"
                  *ngIf="requestData[i]?.isValidFileRange">
                  File exceeded size limit.
                </p>
              </div>
            </div>

            <!-- Category dropdown(s) on the right
            <div class="d-flex align-items-center" *ngIf="showCategory">
              <select class="form-control file-type me-2"
                [ngClass]="requestData[i]?.competencySelected && requestData[i].competencySelected ? 'is-invalid' : ''"
                (change)="categoryChange($event, file, i)">
                <option class="h5">Select Category</option>
                <option class="h5" *ngFor="let category of data.categoryTypes;" [value]="category.id">
                  {{category.category}}
                </option>
              </select>
              <select class="form-control file-type"
                [ngClass]="requestData[i]?.subCompetencySelected && requestData[i].subCompetencySelected ? 'is-invalid' : ''"
                (change)="subCategoryChange($event, file, i)">
                <option class="h5">Select Sub Category</option>
                <option class="h5" *ngFor="let subCategory of subcategory[i];" [value]="subCategory.subCategory">
                  {{subCategory.subCategory}}
                </option>
              </select>
              
            </div> -->

            <!-- Certificate upload section (if applicable) -->
            <div class="d-flex align-items-center" *ngIf="certificateUpload"
              style="flex-direction: column; width: 38%;">
              <div style="display: flex; align-items: center; gap: 5px;">
                <label class="me-2 h5" style="white-space: nowrap; margin-bottom: 0;font-family:inter;font-weight: 600; color: #3A3A3C;">
                  Category<span class="text-danger">*</span>
                </label>
                <select class="form-control file-type mb-2" style="max-width: 228px; height: 40px; margin-top: 10px;"
                  [ngClass]="requestData[i]?.certificateCategorySelected ? 'is-invalid1' : ''"
                  (change)="onSelected($event.target.value, file.dropdown, i)">
                  <option value="" dibed selected hidden>Select Category</option>
                  <option class="h5" *ngFor="let option of file.dropdown.availableOptions" [value]="option">{{option}}
                  </option>
                </select>
                <a (click)="deleteAttachment(file, i)" class="icon"><span
                    class="material-symbols-outlined fs-18 deleteIcon"> delete
                  </span></a>
              </div>
              <div class="otherCategoryName" *ngIf="requestData[i]?.selectedCategory === 'Others'">
                <label class="h5" style="white-space: nowrap; margin-bottom: 0; font-family:inter;font-weight: 600;color: #3A3A3C">
                  Category Name<span class="text-danger" style="gap:3px;">*</span>
                </label>
                <input type="text" class="form-control" style="width: 65%; height: 40px;"
                  placeholder="Enter Category Name" [(ngModel)]="requestData[i].otherCategoryName"
                  name="otherCategoryName{{i}}" required />
              </div>
            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</div>
<div mat-dialog-actions class="review" style="gap: 20px;">
  <button type="button" class="custom_btn inverted_btn_base" style="width: 93px;font-size: 14px;font-weight: 500;height: 45px;"
    (click)="onCancel()">Cancel</button>
  <button type="button" class="custom_btn primary_btn_base" style="width: 93px; height: 45px;font-size: 14px;font-weight: 500;"
    [disabled]="isFileRangeExceeded || (requestData.length == 0 && hasUploadClicked)"
    (click)="addTemplates()">Submit</button>
</div>